module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Turquoise.cd27a747.jpg";